import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useJobPositions } from "../data/positions";
import { getApplicationsPerPosition } from "../callable-cloud-functions/cloudFunctions";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

function PositionApplicantMetrics({ jobId }) {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  );

  const [chartData, setChartData] = useState([]);
  const [chartLabels, setChartLabels] = useState([]);
  const [progress, setProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(true);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Applications Per Position",
      },
    },
    animation: {
      duration: 2000,
      onProgress: function (animation) {
        const progress = animation.currentStep / animation.numSteps;
        const rounded = Math.round((progress + Number.EPSILON) * 100) / 100;
        const converted = rounded * 100;
        setProgress(converted);
      },
      onComplete: function (animation) {
        setTimeout(() => {
          setProgress(0);
          setShowProgress(false);
        }, 2000);
      },
    },
  };

  const data = {
    labels: chartLabels,
    datasets: chartData,
  };

  useEffect(() => {
    (async () => {
      const res = await getApplicationsPerPosition(jobId);
      const datasets = [
        {
          label: "Applications",
          data: [],
          backgroundColor: "#2a6a99",
        },
      ];
      const labels = [];

      for (const applicationsCount of res.data) {
        // res.data.forEach((jobMetric) => {
        console.log(
          "positionsApplicantMetrics.js, applicationsCount: ",
          applicationsCount,
        );
        const positionLabel = Object.getOwnPropertyNames(applicationsCount)[0];
        const applicationPositionCount = applicationsCount[positionLabel];

        labels.push(positionLabel);
        datasets[0].data.push(applicationPositionCount);
      }
      setChartData(datasets);
      setChartLabels(labels);
    })();
  }, []);

  return (
    <div>
      {showProgress ? (
        <div style={{ width: 200, height: 400, margin: "auto" }}>
          <span>Open Job Metrics</span>
          <CircularProgressbar
            value={progress}
            text={`${progress}%`}
            maxValue={50}
          />
        </div>
      ) : (
        <div style={{ display: "none" }} />
      )}
      <div style={{ width: "100%", height: "100%" }}>
        <Bar
          style={showProgress ? { display: "none" } : { display: "block" }}
          options={options}
          data={data}
        />
      </div>
    </div>
  );
}

export default PositionApplicantMetrics;
